export default __webpack_public_path__ + "static/media/search.b5bd84ee.svg";